// src/pages/OurPartnerComingSoon.jsx
import * as React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined";
import { keyframes } from "@mui/system";
import BreadcrumbNav from "./BreadcrumbNav";

// 🔄 rotation animation (30 seconds)
const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export default function OurPartnerComingSoon() {
  const navigate = useNavigate();

  return (
    <>

    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: "linear-gradient(180deg, #f9fafb 0%, #ffffff 100%)",
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={3} alignItems="center" textAlign="center">
          <HourglassTopOutlinedIcon
            sx={{
              fontSize: 80,
              color: "primary.main",
              animation: `${rotate360} 30s linear infinite`,
            }}
          />

          <Typography variant="h3" fontWeight={800} sx={{ letterSpacing: 1 }}>
            Coming Soon
          </Typography>

          <Typography variant="h6" fontWeight={600}>
            Our Partner Page Is on the Way
          </Typography>

          <Typography color="text.secondary">
            We’re currently working on building strong partnerships.
            This page will be live very soon. Stay tuned!
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/")}
            >
              Back to Home
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
    </>
  );
}
